
import AuthService from '@/services/AuthService';

const state = {
  accessToken: localStorage.getItem('estudyoo_admin_c_token') || null,
  djangoToken: localStorage.getItem('estudyoo_django_sync_token') || null,
  error: null,
  isLoading: false,
};

const mutations = {
  setAccessToken(state, token) {
    state.accessToken = token;
    if (token) localStorage.setItem('estudyoo_admin_c_token', token);
    else localStorage.removeItem('estudyoo_admin_c_token');
  },
  setDjangoToken(state, token) {
    state.djangoToken = token;
    if (token) localStorage.setItem('estudyoo_django_sync_token', token);
    else localStorage.removeItem('estudyoo_django_sync_token');
  },
  setError(state, error) {
    state.error = error;
  },
  setLoading(state, isLoading) {
    state.isLoading = isLoading;
  },
};

const actions = {
  async loginWithGoogle({ commit }, googleTokenId) {
    commit('setLoading', true);
    try {
      const response = await AuthService.loginWithGoogle(googleTokenId);
      if (response.data.error) {
        commit('setError', 'Error al iniciar sesión');
      } else {
        commit('setAccessToken', response.data.Token);
      }
    } catch (error) {
      commit('setError', 'Error inesperado');
    } finally {
      commit('setLoading', false);
    }
  },
};

const getters = {
  accessToken: (state) => state.accessToken,
  'access-token': (state) => state.accessToken,
  djangoToken: (state) => state.djangoToken,
  isLoading: (state) => state.isLoading,
  error: (state) => state.error,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
